import React from 'react';

import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import { Button, Tooltip } from '@mui/material';

import { connect } from 'react-redux';

import {
    setSidebarToggle,
    setSidebarToggleMobile
} from '../../../store/reducers/ThemeOptions';

import Version from '../../../components/Version';

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({

}))


const SidebarHeader = (props) => {
    const toggleSidebarMobile = () => {
        setSidebarToggleMobile(!sidebarToggleMobile);
    };
    const toggleSidebar = () => {
        setSidebarToggle(!sidebarToggle);
    };
    const {
        sidebarToggleMobile,
        setSidebarToggleMobile,

        sidebarToggle,
        setSidebarToggle,

        settings
    } = props;

    const { classes, cx } = useStyles();

    return (
        <>
            <div className="app-sidebar--header">
                <div className="app-sidebar-logo">
                    <div className="app-sidebar-logo--icon">
                        <img
                            src={settings.VendorLogoUrl}
                        />
                    </div>
                    <div className="app-sidebar-logo--text">
                        <span></span>

                        <b className="text-white">{settings.VendorName}</b>
                        <Version shortened />
                    </div>

                </div>
                <Tooltip title="Collapse sidebar" placement="right" arrow>
                    <Button
                        onClick={toggleSidebar}
                        className="btn btn-sm collapse-sidebar-btn">
                        <FaArrowCircleLeft />
                    </Button>
                </Tooltip>
                {/* Phones: close the menu. */}
                <Button
                    className={cx(
                        'navbar-toggler toggle-mobile-sidebar-btn pb-menu-btn',
                        { 'is-active': sidebarToggleMobile }
                    )}
                    aria-label="Close menu"
                    onClick={toggleSidebarMobile}>
                    <FiX />
                </Button>
                <Tooltip title="Expand sidebar" placement="right" arrow>
                    <Button
                        onClick={toggleSidebar}
                        className="expand-sidebar-btn btn btn-sm">
                        <FaArrowCircleRight />
                    </Button>
                </Tooltip>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    sidebarToggle: state.ThemeOptions.sidebarToggle,
    sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
    settings: state.settings.settings
});

const mapDispatchToProps = (dispatch) => ({
    setSidebarToggle: (enable) => dispatch(setSidebarToggle(enable)),
    setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarHeader);
